import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/img_error.svg'


const _withScopeId = n => (_pushScopeId("data-v-b1adbbca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "error_contents_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "error_img",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = { class: "error_title" }
const _hoisted_4 = { class: "error_text" }
const _hoisted_5 = { class: "error_button" }

import { computed, Ref } from 'vue';
import BaseButton from '@/components/BaseButton.vue';
import store from '@/store';
import { useRouter } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorView',
  setup(__props) {

const router = useRouter();

const transitionTopPage = () => {
  store.commit('error/initErrorState');
  router.push({ name: 'f00' });
};

const errorState: Ref<null | number> = computed(() => store.getters['error/errorState']);

if (errorState.value === null) {
  transitionTopPage();
}

const errorTitle = computed(() => {
  switch (errorState.value) {
    case 401:
      return '401 Unauthorized';
    case 500:
      return '500 Internal Server Error';
    case 503:
      return '503 Service Temporarily Unavailable';
    default:
      return '';
  }
});

const errorText = computed(() => {
  switch (errorState.value) {
    case 401:
      return 'アクセスしようとしたページは表示できませんでした。';
    case 500:
      return 'システムエラーが発生しました。\r\nお手数ですが、しばらく時間を置いてから再度お試しください。';
    case 503:
      return '只今メンテナンス中です。\r\nお手数ですが、しばらく時間を置いてから再度お試しください。';
    default:
      return '';
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(errorTitle)), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(errorText)), 1),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(BaseButton, {
          theme: "primary",
          onClick: transitionTopPage
        }, {
          default: _withCtx(() => [
            _createTextVNode("ホームへ戻る")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})